import { render, staticRenderFns } from "./NavMenuMain.vue?vue&type=template&id=52310351&scoped=true&"
import script from "./NavMenuMain.vue?vue&type=script&lang=ts&"
export * from "./NavMenuMain.vue?vue&type=script&lang=ts&"
import style0 from "./NavMenuMain.vue?vue&type=style&index=0&id=52310351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52310351",
  null
  
)

export default component.exports